module.exports = __webpack_public_path__ + "static/media/heroBack7.61a9d0cc.svg";